import React, { useEffect } from 'react'
import Layout from './layout/Layout'

const Dashboard = () => {
  return (
    <div>
      <Layout/>
    </div>
  )
}

export default Dashboard
